import { Image } from 'antd';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import IconEdit from './IconEdit';
import { useEffect, useRef } from 'react';

export default function MenuLabel(props: any) {

    const ref = useRef<any>(undefined);

    /** api服务id */
    const apiId = 'icon';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '图标名称',
            dataIndex: 'iconName',
        },
        {
            title: '图标',
            dataIndex: 'iconSrc',
            // render: (text: any, record: any) => {
            //     return (
            //         <Image width={50} src={text} />
            //     )
            // }
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '图标',
        apiId,
        showStates: true,
        columns,
        pagination: true,
        EditComponent: IconEdit
    };

    return (
        <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
    )
}